import React from 'react'
import "./HeaderOne.css";

const HeaderOne = () => {
  return (
    <div className='header-one'>The health and well-being of our patients and their health care team will always be our priority, so we follow the best practices for cleanliness.</div>
  )
}

export default HeaderOne